import { Button } from "antd";
import React from "react";

function BlueTooth (props) {
    const { device, onClose } = props;

    return (
        <Button
            onClick={() => {
                const isPaired = device.isPaired();
                if (!isPaired) {
                    device.pairing = true;
                }

                // 关闭弹窗
                onClose();
            }}
        >
            蓝牙配对
        </Button>
    );
}

export default BlueTooth;